/*
 * SPDX-License-Identifier: Apache-2.0
 *
 * The OpenSearch Contributors require contributions made to
 * this file be licensed under the Apache-2.0 license or a
 * compatible open source license.
 *
 * Modifications Copyright OpenSearch Contributors. See
 * GitHub history for details.
 */

/*
 * Licensed to Elasticsearch B.V. under one or more contributor
 * license agreements. See the NOTICE file distributed with
 * this work for additional information regarding copyright
 * ownership. Elasticsearch B.V. licenses this file to you under
 * the Apache License, Version 2.0 (the "License"); you may
 * not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import React, { useState, createContext } from 'react';
import { DragDropContext } from 'react-beautiful-dnd';

// export interface OuiDragDropContextProps extends DragDropContextProps {}

export var OuiDragDropContextContext = /*#__PURE__*/createContext({
  isDraggingType: null
});
export var OuiDragDropContext = ({
  onBeforeDragStart,
  onDragStart,
  onDragUpdate,
  onDragEnd,
  children,
  ...rest
}) => {
  const [isDraggingType, setIsDraggingType] = useState(null);
  const ouiOnDragStart = (start, provided) => {
    setIsDraggingType(start.type);
    if (onDragStart) {
      onDragStart(start, provided);
    }
  };
  const ouiOnDragEnd = (result, provided) => {
    setIsDraggingType(null);
    if (onDragEnd) {
      onDragEnd(result, provided);
    }
  };
  return <DragDropContext onBeforeDragStart={onBeforeDragStart} onDragStart={ouiOnDragStart} onDragUpdate={onDragUpdate} onDragEnd={ouiOnDragEnd} {...rest}>
      <OuiDragDropContextContext.Provider value={{
      isDraggingType
    }}>
        {children}
      </OuiDragDropContextContext.Provider>
    </DragDropContext>;
};
try {
  OuiDragDropContext.__docgenInfo = {
    tags: {},
    filePath: '/codebuild/output/src3077135706/src/src/components/drag_and_drop/drag_drop_context.tsx',
    description: '',
    displayName: 'OuiDragDropContext',
    methods: [],
    props: {
      dragHandleUsageInstructions: {
        defaultValue: null,
        description: '',
        name: 'dragHandleUsageInstructions',
        parent: {
          fileName: 'src/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'src/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      nonce: {
        defaultValue: null,
        description: '',
        name: 'nonce',
        parent: {
          fileName: 'src/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'src/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'string'
        }
      },
      enableDefaultSensors: {
        defaultValue: null,
        description: '',
        name: 'enableDefaultSensors',
        parent: {
          fileName: 'src/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'src/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'boolean'
        }
      },
      sensors: {
        defaultValue: null,
        description: '',
        name: 'sensors',
        parent: {
          fileName: 'src/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        },
        declarations: [{
          fileName: 'src/node_modules/@types/react-beautiful-dnd/index.d.ts',
          name: 'DragDropContextProps'
        }],
        required: false,
        type: {
          name: 'Sensor[]'
        }
      }
    },
    extendedInterfaces: ['Responders']
  };
} catch (e) {}